var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyprEdgeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1044,
    height: 118,
    viewBox: "0 0 1044 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3707_70361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.682 109.969C184.045 109.969 182.238 109.996 180.302 110C174.999 109.969 174.195 108.573 173.952 104.941C174.239 93.5922 173.943 82.2351 174.118 70.8838C174.172 67.3501 173.155 64.3761 170.9 61.2638C157.252 42.432 143.964 23.4334 130.407 4.55905C128.175 1.45218 127.983 -0.169015 133.274 0.174609C133.54 0.191871 133.81 0.181767 134.077 0.174884C157.74 -0.434544 157.596 -0.37153 169.107 16.4966C178.055 29.6075 187.367 42.56 196.632 55.5306C199.472 59.507 201.111 63.5003 200.949 68.2419C200.564 79.5866 200.368 90.9617 201.008 102.292C201.353 108.4 199.129 109.969 191.454 109.996C190.158 109.808 188.783 109.969 186.682 109.969Z",
    fill: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.861 23.7484C227.514 31.6721 221.395 39.1867 214.917 47.1429C209.245 42.3256 205.885 36.6863 201.544 31.5527C200.207 29.972 201.594 28.4379 202.673 27.0427C208.831 19.0857 215.055 11.1571 221.162 3.17865C222.785 1.05927 224.824 -0.0520779 228.254 0.00187549C236.305 0.128514 244.361 0.0423893 253.878 0.0423893C246.842 8.32506 240.466 15.8322 233.861 23.7484Z",
    fill: "#D21D71"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3707_70361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855.92 0.629527C824.69 4.30439 804.202 25.4348 804.003 54.4662C803.804 83.6813 825.088 105.73 857.511 109.589C870.838 111.243 890.729 107.752 902.664 101.872L912.013 97.0946V75.2292V53.5475H901.073H890.132V70.0844C890.132 86.4375 890.132 86.805 884.762 88.8261C881.579 89.9286 873.822 91.0311 867.059 91.0311C856.914 91.2148 853.533 90.2961 845.377 85.7025C831.453 77.8016 825.884 67.3282 827.077 52.0776C827.873 42.7067 829.265 39.0318 833.84 33.7033C844.78 21.3925 848.759 19.555 867.059 19.555C881.977 19.555 884.364 20.1063 891.923 24.8836L900.277 30.2121L907.04 24.1486L914.002 17.9014L909.427 13.4915C899.68 3.56941 877.004 -1.94287 855.92 0.629527Z",
    fill: "#6B0BEA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3707_70361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 55V110H16.1635H28.3269V86.6949V63.3898H60.3942H92.4615V86.6949V110H105.731H119L118.558 55.3729L117.894 0.932204H105.731H93.5673L92.9038 22.7458L92.2404 44.7458H60.3942H28.3269V22.3729V8.9407e-07H16.1635H4V55Z",
    fill: "#6B0BEA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3707_70361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.017 55.0927V110H280.973H292.928V94.2327V78.4654H312.71C337.057 78.4654 348.795 76.054 359.012 68.8196C370.099 61.0287 373.794 53.7943 374.012 40.4384C374.229 23.9292 367.49 14.2833 350.752 7.2344C338.796 2.04047 336.405 1.66947 303.58 0.927483L269.017 -4.24683e-06V55.0927ZM335.1 21.7032C348.578 26.5261 353.36 38.769 346.404 50.4553C341.839 57.8752 334.231 59.9157 312.493 59.9157H292.928V39.511V19.1062H310.319C320.318 19.1062 330.97 20.2192 335.1 21.7032Z",
    fill: "#6B0BEA"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3707_70361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.998 55.0927V110H411.074H423.15V94.2327V78.4654H439.178H455.425L468.16 94.2327L481.114 110H495.166H508.998L494.287 92.0067C485.066 80.8769 480.455 73.828 482.212 73.2715C487.262 71.7875 498.02 63.0691 501.533 57.5042C503.509 54.1653 505.046 46.9309 505.046 40.4384C505.266 23.9292 498.459 14.2833 481.553 7.2344C469.477 2.04047 467.062 1.66947 433.908 0.927483L398.998 -4.24683e-06V55.0927ZM465.745 21.7032C479.357 26.5261 484.188 38.769 477.162 50.4553C472.771 57.5042 464.647 60.1012 442.471 61.2142L423.15 62.3271V40.6239V19.1062H440.715C450.814 19.1062 461.573 20.2192 465.745 21.7032Z",
    fill: "#6B0BEA"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3707_70361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.961 55V110H691.238C727.313 110 740.393 107.763 754.95 98.8136C772.249 88.1864 780.265 72.339 778.789 51.4576C777.312 31.5085 768.029 18.2712 749.043 8.57627C736.174 2.05085 721.617 8.9407e-07 688.496 8.9407e-07H658.961V55ZM725.837 20.8814C747.566 25.5424 759.802 46.0508 752.84 66.1864C746.722 84.4576 732.798 91.3559 702.209 91.3559H682.167V55V18.6441H699.255C708.538 18.6441 720.562 19.5763 725.837 20.8814Z",
    fill: "#6B0BEA"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3707_70361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M949.044 55V110H994.146H1039.04L1038.43 101.051L1037.82 92.2881L1004.76 91.7288L971.493 91.3559V77.3729V63.3898H1000.27H1028.84L1028.23 54.4407L1027.62 45.678L999.656 45.1186L971.493 44.5593V31.6949V18.6441H1004.35H1037L1036.39 9.69492L1035.78 0.932204L992.513 0.372882L949.044 8.9407e-07V55Z",
    fill: "#6B0BEA"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3707_70361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.25 91.6666C628.859 91.6673 628.859 91.6673 628.859 101.284C628.859 102.626 628.694 103.984 628.891 105.307C629.397 108.713 627.918 110.024 623.422 110C596.859 109.856 570.293 109.869 543.729 109.992C539.853 110.01 538.593 108.884 539.087 105.996C539.12 105.808 539.095 105.613 539.09 105.421C538.709 91.6667 538.709 91.6667 555.773 91.6667C575.697 91.6667 595.62 91.6667 616.25 91.6666Z",
    fill: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.08 45.8333C608.887 45.834 608.887 45.834 608.887 55.4509C608.887 56.793 608.759 58.1511 608.912 59.4741C609.305 62.8794 608.155 64.1905 604.658 64.1663C583.998 64.0233 563.336 64.0363 542.675 64.1588C539.66 64.1766 538.68 63.0506 539.065 60.1625C539.09 59.9745 539.071 59.7795 539.067 59.5878C538.771 45.8335 538.771 45.8335 552.043 45.8335C567.539 45.8335 583.034 45.8334 599.08 45.8333Z",
    fill: "#D21D71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.25 0C628.859 0.000703098 628.859 0.000703504 628.859 9.6176C628.859 10.9597 628.694 12.3177 628.891 13.6407C629.397 17.0461 627.918 18.3572 623.422 18.333C596.859 18.1899 570.293 18.2029 543.729 18.3254C539.853 18.3433 538.593 17.2173 539.087 14.3292C539.12 14.1411 539.095 13.9461 539.09 13.7545C538.709 0.000131907 538.709 0.000141128 555.773 0.000131907C575.697 0.000122686 595.62 0.000104888 616.25 0Z",
    fill: "#6B0BEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3707_70361",
    x: 124.928,
    y: 0,
    width: 132.95,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3707_70361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3707_70361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3707_70361",
    x: 800.002,
    y: 0,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3707_70361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3707_70361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3707_70361",
    x: 0,
    y: 0,
    width: 123,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3707_70361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3707_70361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3707_70361",
    x: 265.017,
    y: 0,
    width: 113,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3707_70361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3707_70361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3707_70361",
    x: 394.998,
    y: 0,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3707_70361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3707_70361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3707_70361",
    x: 654.961,
    y: 0,
    width: 128,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3707_70361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3707_70361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3707_70361",
    x: 945.044,
    y: 0,
    width: 98,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3707_70361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3707_70361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3707_70361",
    x: 534.985,
    y: 0,
    width: 98,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3707_70361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3707_70361",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyprEdgeLogo);
export default __webpack_public_path__ + "static/media/HyprEdge-Logo.451ae37148dd5b7917927d9636c163a0.svg";
export { ForwardRef as ReactComponent };